module.exports = __webpack_public_path__ + "img/flame.e8ef3b34.svg";